import 'flowbite';
import { Accordion } from "./accordion";
import { loadYouTubeScript } from './customPlayerYoutube.js';
import { loadVimeoScript } from './customPlayerVimeo.js';
import "@web/Views/Partials/blockgrid/Components/textSecondaryTitleHighlightContentBlock/textSecondaryTitleHighlightContentBlock.js";
import "@web/Views/Partials/blockgrid/Components/textTwoColsCompareMobileAccordionBlock/TextTwoColsCompareMobileAccordionBlock.js";
import "@web/Views/Partials/blockgrid/Components/meetImgBackgroundBlock/meetImgBackgroundBlock.js";
import swiper from "@web/Views/Partials/blockgrid/Components/GalleryBlock/GalleryBlock.js";
import RelatedProduct from "@web/Views/Partials/blockgrid/Components/relatedProductsMobileSliderBlock/relatedProductsMobileSliderBlock.js";
import swipersliderPreview from "@web/Views/Partials/blockgrid/Components/sliderProductPreviewBlock/sliderProductPreviewBlock.js";
import { SliderBlock } from "@web/Views/Partials/blockgrid/Components/primarySliderBlock/primarySliderBlock.js";
import HamburgerMenu from "@web/Views/Partials/Navigation/hamburger/hamburger.js";
import footer from "@web/Views/Partials/Navigation/footer/footer.js";
import { initMenuAccordion } from "@web/Views/Partials/Navigation/accordion/accordion.js";
import SearchLayer from "@web/Views/Partials/search/search-layer.js";
import OffcanvasLayer from "@web/Views/Partials/login/offcanvas.js";
import Forms from "./form.js";
import { applyHeight } from './PrivateBanking.js';
import { slideNews, slideStories } from "@web/Views/Partials/blockgrid/Components/newsStorieSliderBlock/newsStorieSliderBlock.js";
import { SliderTextImageRightBlock } from "@web/Views/Partials/blockgrid/Components/sliderTextImageRightBlock/sliderTextImageRightBlock.js";

import ScrollToTop from '@web/Views/Partials/scrollToTop/scrollToTop.js';
import menuInvestorRelations from "@web/Views/Partials/Navigation/sidebar/menuSidebarDesktop.js";
import titleSubtitleYearFilterBlockFun from "@web/Views/Partials/blockgrid/Components/titleSubtitleYearFilterBlock/titleSubtitleYearFilterBlock.js";
import secondaryMenu from "@web/Views/Partials/Navigation/secondaryMenu.js";
import LeftImageTitleTextAccordionBlock from "@web/Views/Partials/blockgrid/Components/leftImageTitleTextAccordionBlock/leftImageTitleTextAccordionBlock.js";

import SliderSlideImageTitleText from "@web/Views/Partials/blockgrid/Components/sliderSlideImageTitleText/sliderSlideImageTitleText.js";

import { AutoSliderBlock } from "@web/Views/Partials/sparkasse_auto/autoSliderBlock/autoSliderBlock.js";
import { AutoFiltersBlock } from "@web/Views/Partials/sparkasse_auto/autoGridBlock/autoGridFilters.js";
import signature from './signature.js';
import anchorLink from './anchor-link.js';
import servicesMenu from '@web/Views/Partials/Navigation/services-menu.js';
import { initFormattedInput, formatNumbers, initDropdowns, TextAreaString } from './tool-forms.js';
import FormValidation from './form-validation.js';
import businessFinanceQuizToolBlock from '@web/Views/Partials/blockgrid/Components/businessFinanceQuizToolBlock/businessFinanceQuizToolBlock.js';
import resetOnChange from '@web/Views/Shared/loadingChangeOrientation/loadingChangeOrientation.js';


// Inizializza elementi al caricamen to della pagina
document.addEventListener("DOMContentLoaded", () => {

    // signature();

    // accordion
    const accordions = document.querySelectorAll(".accordion .accordion-header");
    accordions.forEach((accordionEl) => {
        new Accordion(accordionEl);

    });

    // Slider-Gallery
    const swiperElement = document.querySelector(".slider-gallery");
    if (swiperElement) {
        swiper();
    }


    // Primary Slider
    const swiperSlider = document.querySelector(".primary-slider-block");
    if (swiperSlider) {
        SliderBlock();
    }

    // Primary Slider preview
    const swiperSliderElement = document.querySelector(".slider-preview");
    if (swiperSliderElement) {
        swipersliderPreview();
    }

    const swiperElementNews = document.querySelector(".slide-news");
    if (swiperElementNews) {
        slideNews();
    }

    const swiperElementStories = document.querySelector(".slide-stories");
    if (swiperElementStories) {
        slideStories();
    }
    const swiperElementRelatedProduct = document.querySelector(".slide-related-product");
    if (swiperElementRelatedProduct) {
        RelatedProduct()
    }


    const SliderElementTextImageRightBlock = document.querySelector(".SliderTextImageRightBlock");
    if (SliderElementTextImageRightBlock) {
        SliderTextImageRightBlock();
    }

    const titleSubtitleYearFilterBlock = document.querySelector(".titleSubtitleYearFilterBlock");
    if (titleSubtitleYearFilterBlock) {
        titleSubtitleYearFilterBlockFun();
    }

    const InvestorRelationsTabs = document.querySelector(".investorRelationsTabs");
    if (InvestorRelationsTabs) {
        InvestorRelationsTabs();
    }

    const leftImageTitleTextAccordionBlock = document.querySelector(".leftImageTitleTextAccordionBlock");
    if (leftImageTitleTextAccordionBlock) {
        LeftImageTitleTextAccordionBlock();
    }
    const sliderSlideImageTitleText = document.querySelector(".sliderSlideImageTitleText");
    if (sliderSlideImageTitleText) {
        SliderSlideImageTitleText();
    }

    initMenuAccordion();

    HamburgerMenu();
    SearchLayer();
    OffcanvasLayer();
    ScrollToTop();
    footer();

    menuInvestorRelations();
    secondaryMenu();

    loadVimeoScript();
    loadYouTubeScript();
    anchorLink();
    servicesMenu();

    Forms();
    businessFinanceQuizToolBlock();

    FormValidation();
    const privateBankingBody = document.querySelector(".page-type-privateBankingPage");
    if (privateBankingBody) {
        applyHeight();
    }

    // Passa l'elemento target per la formattazione input
    document.querySelectorAll(".input-import").forEach(input => {
        initFormattedInput(input);
    });

    // Applica formattazione numerica agli elementi con classe .formatNumb
    formatNumbers();
    const modalBody = document.getElementById("wee");
    if (modalBody) {
        TextAreaString()

    }

    // Inizializza dropdown solo se TomSelect non è già attivo
    document.querySelectorAll(".tomselect-dropdown").forEach(el => {
        if (!el.classList.contains('ts-wrapper')) {
            // Verifica che TomSelect non sia già inizializzato
            initDropdowns();
        }
    });

    // Sparkasse Auto Slider
    const SELECTOR_AUTO_SLIDER = ".spk-auto-slider-block";
    const autoSlider = document.querySelector(SELECTOR_AUTO_SLIDER);
    if (autoSlider) AutoSliderBlock(SELECTOR_AUTO_SLIDER);

    // Sparkasse Auto Filters
    const SELECTOR_AUTO_FILTERS = ".spk-auto-grid-filter-row";
    const SELECTOR_AUTO_GRID = ".spk-auto-grid-block";
    const autoFilters = document.querySelector(SELECTOR_AUTO_FILTERS);
    if (autoFilters) AutoFiltersBlock(SELECTOR_AUTO_FILTERS, SELECTOR_AUTO_GRID);
    // Assicura che il link "Skip to Content" funzioni correttamente

    const skipLink = document.querySelector('a[href="#main-content"]');
    const mainContent = document.getElementById('main-content');

    if (skipLink && mainContent) {
        skipLink.addEventListener('click', function (e) {
            // Impedisce il comportamento predefinito del link
            e.preventDefault();
            mainContent.focus();
            mainContent.scrollIntoView();


        });
    }

    // Rimuove la classe .svg-display-delay per mostrare le SVG
    document.querySelectorAll('.svg-display-delay').forEach(el => {
        el.classList.remove('hidden');
    });

    resetOnChange();

});





